import {AvalancheReelsModule} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsModule';
import {GameAvalancheReelsDropNewState} from 'src/avalanche/states/GameAvalancheReelsDropNewState';
import {GameAvalancheRemoveWinsState} from 'src/avalanche/states/GameAvalancheRemoveWinsState';
import {GameAvalancheAddSymbolsState} from 'src/avalanche/states/GameAvalancheAddSymbolsState';
import {GameAvalancheRespinState} from 'src/avalanche/states/GameAvalancheRespinState';
import {RespinEvents} from 'src/respin/RespinEvents';
import {GameRecodeLogic} from 'src/logic/recode/GameRecodeLogic';
import {GameAvalancheReelsView} from 'src/avalanche/GameAvalancheReelsView';
import {GameAvalancheReelsEvents} from 'src/avalanche/GameAvalancheReelsEvents';
import {GameFlowEvents} from 'src/flow/GameFlowEvents';
import {WildMeterEvents} from 'src/wildmeter/WildMeterEvents';
import {PrototypeWinLine} from '@fantasmagames/slot/src/logic/prototype/PrototypeSpinResult';
import {RecodeLogic} from '@fantasmagames/slot/src/logic/integration/RecodeLogic';
import {FreeSpinsEvents} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsEvents';
import {GameAvalancheReelsInitState} from 'src/avalanche/states/GameAvalancheReelsInitState';
import {FreeSpinsTriggerModule} from 'src/freespinstrigger/FreeSpinsTriggerModule';
import {SymbolPosition} from '@fantasmagames/slot/src/modules/reels/ReelConstants';
import {GameReelsStats} from 'src/avalanche/GameReelsStats';
import {GameAvalancheConstants, GameReelConstants} from 'src/reels/GameReelConstants';
import {GameBackgroundModule} from 'src/background/GameBackgroundModule';

export class GameAvalancheReelsModule extends AvalancheReelsModule {

	protected _spinPressedTimestamp: number;

	public restore(): void {
		this.view.createReelSet((this.logic as RecodeLogic).getRecodeSpinResults().reels);
		(this.view as GameAvalancheReelsView).updateIdleAnimationOnRestore();
	}

	public afterInit(): void {
		super.afterInit();

		if ((window as any)._certificationSettings && (window as any)._certificationSettings.hasOwnProperty('spinDelay')) {
			GameReelsStats.IS_ON_REGULATED_MARKET = true;
			GameReelsStats.MINIMUM_TIME_TO_FINISH_DROP = (GameReelConstants.ROW_AMOUNT - 1) * GameAvalancheConstants.TIMER_BETWEEN_SYMBOLS_NEW
				+ (GameReelConstants.REELS_AMOUNT - 1) * GameAvalancheConstants.TIMER_BETWEEN_REELS_NEW
				+ GameAvalancheConstants.AVALANCHE_NEW_TIMER;
			GameReelsStats.EXPECTED_TIME_ON_REGULATED_MARKET = (window as any)._certificationSettings.spinDelay;
		}

		GameAvalancheConstants.initDropConfigs(GameReelsStats.IS_ON_REGULATED_MARKET);
	}

	public setupDefaultReelset(): void {

	}

	protected setupStates(): void {
		super.setupStates();

		this.addState(new GameAvalancheReelsDropNewState(this, AvalancheReelsModule.DROPNEW_STATE));
		this.addState(new GameAvalancheRemoveWinsState(this, AvalancheReelsModule.REMOVE_WINS_STATE));
		this.addState(new GameAvalancheAddSymbolsState(this, AvalancheReelsModule.ADD_SYMBOLS_STATE));
		this.addState(new GameAvalancheRespinState(this, AvalancheReelsModule.RESPIN_STATE));
		this.addState(new GameAvalancheReelsInitState(this, AvalancheReelsModule.INIT_STATE));
	}

	protected setupEvents(): void {
		super.setupEvents();

		this.onCurrentStateHandle(RespinEvents.LEAVING_SCATTER_AT);
		this.onCurrentStateHandle(RespinEvents.LEAVING_SYMBOL_AT);
		this.onCurrentStateHandle(RespinEvents.RESPIN_REMOVING_FINISHED);
		this.onCurrentStateHandle(WildMeterEvents.WIN_METER_WILDS_ANIMATIONS_FINISHED);

		this.onViewEmitEvent(GameAvalancheReelsView.INITIAL_WIN_INDICATION_FINISHED, GameAvalancheReelsEvents.WIN_HIGHLIGHTING_FINISHED);
		this.onViewEmitEvent(GameAvalancheReelsView.INITIAL_WIN_INDICATION_STARTED, GameAvalancheReelsEvents.WIN_HIGHLIGHTING_STARTED);
		this.onViewEmitEvent(GameAvalancheReelsView.INITIAL_WIN_INDICATION_WINLINE, GameAvalancheReelsEvents.WIN_HIGHLIGHTING_WINLINE);
		this.onViewEmitEvent(GameAvalancheReelsView.SYMBOL_PASSED_THROUGHT_LINE, GameAvalancheReelsEvents.SYMBOL_PASSED_THROUGHT_LINE);
		this.onViewEmitEvent(GameAvalancheReelsView.SCATTER_ATTENTION_TRIGGERED, GameAvalancheReelsEvents.SCATTER_ATTENTION_TRIGGERED);
		this.onViewEmitEvent(GameAvalancheReelsView.RESPIN_ATTENTION_TRIGGERED, GameAvalancheReelsEvents.RESPIN_ATTENTION_TRIGGERED);
		this.onViewEmitEvent(GameAvalancheReelsView.FILLING_VOIDS_STARTED, GameAvalancheReelsEvents.FILLING_VOIDS_STARTED);

		this.on(GameFlowEvents.HAS_WIN_SYMBOLS_TO_HIGHLIGHT, this.onHasSymbolToHighlight);
		this.on(FreeSpinsEvents.FREE_SPINS_OUTRO_CONTINUE_CLICKED, this.onFreeSpinsOutroContinueClicked);
		this.on(FreeSpinsTriggerModule.LEAVING_BONUS_AT, this.onLeavingBonusAt);
		this.on(FreeSpinsTriggerModule.BONUS_TRIGGER_ANIMATION_FINISHED_AT, this.onBonusTriggerAnimationFinishedAt);
		this.on(GameBackgroundModule.TRANSITION_ANIMATION_STARTED, this.onTransitionAnimationStarted);
	}

	protected onSpinButtonPressed(): void {
		super.onSpinButtonPressed();

		this._spinPressedTimestamp = new Date().getTime();
	}

	protected onSpinResponseReceived(): void {
		super.onSpinResponseReceived();

		GameReelsStats.TIME_SINCE_SPIN_PRESSED = new Date().getTime() - this._spinPressedTimestamp;
	}

	protected onHasSymbolToHighlight(): void {
		const logic: GameRecodeLogic = this.logic as GameRecodeLogic;

		const winLines: PrototypeWinLine[] = logic.getAllWinLinesFromCurrentRound();

		(this.view as GameAvalancheReelsView).addWinIndicationToSymbols(winLines);
	}

	protected onFreeSpinsOutroContinueClicked(): void {
		this.view.createReelSet((this.logic as GameRecodeLogic).freeSpinsTriggerSymbols);
	}

	protected onLeavingBonusAt(eventID: string, symPos: SymbolPosition): void {
		(this.view as GameAvalancheReelsView).removeIdleAnimationAt(symPos);
	}

	protected onBonusTriggerAnimationFinishedAt(eventID: string, symPos: SymbolPosition): void {
		(this.view as GameAvalancheReelsView).startBonusIdleAnimationAt(symPos);
	}

	protected onStartScreenIntroStarted(): void {
		(this.view as GameAvalancheReelsView).setReelsContainerAlphaToZero();
	}

	protected onTransitionAnimationStarted(): void {
		(this.view as GameAvalancheReelsView).playReelContainerTransition();
	}

	protected onStartScreenIntroFinished(): void {
	}
}



// WEBPACK FOOTER //
// ./src/avalanche/GameAvalancheReelsModule.ts